import { useTranslation } from 'react-i18next'
import { TMedAlert, MED_ALERT_UI_TO_TAG_STATUS } from 'src/types/med-alert'
import { TPatientLocale } from 'src/types/locales'
import { useState, useEffect } from 'react'
import { CrossIcon, CurecallTag, CurecallTextButton, RoundInfoIcon } from '@honestica/curecall-ui'

interface MedAlertSuggestionProps {
  suggestions: TMedAlert[]
  language: TPatientLocale
  onSuggestionClick: (medAlertId: number) => void
}

export function MedAlertSuggestion({
  suggestions,
  language,
  onSuggestionClick,
}: Readonly<MedAlertSuggestionProps>) {
  const { t } = useTranslation()
  const [isClosed, setIsClosed] = useState(false)

  useEffect(() => {
    if (suggestions.length > 0) {
      setIsClosed(false)
    }
  }, [suggestions])

  if (suggestions.length === 0 || isClosed) {
    return null
  }

  return (
    <div className="c-mt-2 c-w-full c-border c-border-grey-500 c-rounded-lg c-bg-blue-50 c-overflow-hidden c-shadow-sm">
      <div className="c-flex c-items-center c-justify-between c-px-4 c-py-2 c-bg-grey-100 c-border-b c-border-grey-500">
        <div className="c-flex c-items-center c-gap-2">
          <RoundInfoIcon className="c-h-5 c-w-5 c-text-primary-400" />
          <span className="c-text-sm c-text-gray-700 c-font-medium">
            {t('pages.configuration.followups.chatbot.med-alert-modal.similar-alerts-title')}
          </span>
        </div>
        <button
          type="button"
          onClick={() => setIsClosed(true)}
          className="c-text-gray-700 hover:c-text-gray-900 c-transition-colors c-flex-shrink-0"
          aria-label={t('common.actions.close')}
        >
          <CrossIcon className="c-h-5 c-w-5" />
        </button>
      </div>
      <div className="c-bg-white c-divide-y c-divide-grey-500">
        {suggestions.map((medAlert) => (
          <div
            key={medAlert.id}
            className="c-flex c-items-center c-justify-between c-px-4 c-py-1 hover:c-bg-gray-50 c-transition-colors"
          >
            <CurecallTag status={MED_ALERT_UI_TO_TAG_STATUS[medAlert.ui]} size="sm">
              {medAlert.intlLabel?.[language]}
            </CurecallTag>
            <CurecallTextButton
              type="button"
              className="c-whitespace-nowrap c-text-sm"
              onClick={() => onSuggestionClick(medAlert.id)}
            >
              {t('pages.configuration.followups.chatbot.med-alert-modal.select-alert')}
            </CurecallTextButton>
          </div>
        ))}
      </div>
    </div>
  )
}
